import { createFileRoute } from "@tanstack/react-router";
import { BASE_URL } from "@/lib/constants";
import { generateSeo } from "@/lib/utils/seo";

export const Route = createFileRoute("/_legal/terms")({
	head: () =>
		generateSeo({
			title: "Terms & Conditions | CraftLayer",
			description:
				"Read our terms and conditions to understand the rules and regulations for using our website and services.",
			url: `${BASE_URL}/terms`,
			keywords: ["terms and conditions", "terms of use", "legal", "CraftLayer"],
		}),
});
